import * as AlertBarState from '../../components/alert-bar/AlertBar.state';
import * as Nested from '../../utils/Nested';
import * as ModalState from '../../components/modal/Modal.state';
import { ReceiptForm } from '../../components/receipt-form-module';
import { PAYMENT_SUCCESS } from '../checkout/Checkout.state';
import { formatCurrency } from '../../utils/helpers';
import { VoidForm } from './OrderDetailsVoidModal';
import { ReturnForm } from './OrderDetailsReturnModal';

// Default State
const initialState = {
  error: false,
  data: {},
  isLoading: false,
  isPrintReceiptLoading: false,
  isSendReceiptLoading: false,
  isVoidModalOpen: false,
  isReturnModalOpen: false,
  isChangeDueModalOpen: false,
  isVoidError: false,
  isCardReturnError: false,
  isReopenOrderError: false,
  changeDue: 0,
  isPaylinkError: false,
  isPaylinkCancelled: false,
};

// Action Creators and Action Types
export const GET_ORDER_DETAILS_REQUEST = 'GET_ORDER_DETAILS_REQUEST';
export const getOrderDetailsRequest = (data) => ({
  type: GET_ORDER_DETAILS_REQUEST,
  payload: data,
});

export const GET_ORDER_DETAILS_SUCCESS = 'GET_ORDER_DETAILS_SUCCESS';
export const getOrderDetailsSuccess = (data) => ({
  type: GET_ORDER_DETAILS_SUCCESS,
  payload: data,
});

export const GET_ORDER_DETAILS_ERROR = 'GET_ORDER_DETAILS_ERROR';
export const getOrderDetailsError = (data) => ({
  type: GET_ORDER_DETAILS_ERROR,
  payload: data,
});

// Alert Bar Nested Actions
export const ALERT_BAR_ACTION = 'orderDetails/ALERT_BAR_ACTION';
export const orderDetailsAlertBarAction = Nested.nestedAction(ALERT_BAR_ACTION);

// Modal Nested Actions
export const LOADING_MODAL_ACTION = 'orderDetails/LOADING_MODAL_ACTION';
export const orderDetailsLoadingModalAction =
  Nested.nestedAction(LOADING_MODAL_ACTION);
export const VOIDING_MODAL_ACTION = 'orderDetails/VOIDING_MODAL_ACTION';
export const orderDetailsVoidingModalAction =
  Nested.nestedAction(VOIDING_MODAL_ACTION);
export const REFUNDING_MODAL_ACTION = 'orderDetails/REFUNDING_MODAL_ACTION';
export const orderDetailsRefundingModalAction = Nested.nestedAction(
  REFUNDING_MODAL_ACTION,
);

export const CHANGE_DUE_MODAL_ACTION = 'orderDetails/CHANGE_DUE_MODAL_ACTION';
export const orderDetailsChangeDueModalAction = Nested.nestedAction(
  CHANGE_DUE_MODAL_ACTION,
);

// Void Action
export const INITIATE_VOID = 'INITIATE_VOID';
export const initiateVoidOrderById = (data) => ({
  type: INITIATE_VOID,
  payload: data,
});

// Void Success Action
export const VOID_SUCCESS = 'VOID_SUCCESS';
export const voidSuccess = (data) => ({
  type: VOID_SUCCESS,
  payload: data,
});

// Void Error action
export const VOID_ERROR = 'VOID_ERROR';
export const voidError = (data) => ({
  type: VOID_ERROR,
  payload: data,
});

// Intentionally distinct from cart's STOP_VOID_TRANSACTION_POLLING: each void
// polling loop's takeUntil listens only for its own stop type. Unifying the two
// would let one stop signal cross-terminate a concurrent void loop in the other epic.
export const STOP_VOID_ORDER_POLLING = 'STOP_VOID_ORDER_POLLING';
export const stopVoidOrderPolling = () => ({
  type: STOP_VOID_ORDER_POLLING,
});

// Return Action
export const INITIATE_RETURN = 'INITIATE_RETURN';
export const initiateReturnOrderById = (data) => ({
  type: INITIATE_RETURN,
  payload: data,
});

// Return Success Action
export const RETURN_SUCCESS = 'RETURN_SUCCESS';
export const returnSuccess = (data) => ({
  type: RETURN_SUCCESS,
  payload: data,
});

// Return Error Action
export const RETURN_ERROR = 'RETURN_ERROR';
export const returnError = (data) => ({
  type: RETURN_ERROR,
  payload: data,
});

// Re-open Action
export const INITIATE_REOPEN = 'INITIATE_REOPEN';
export const initiateReopenOrderById = (id) => ({
  type: INITIATE_REOPEN,
  payload: id,
});

// Re-open Success Action
export const REOPEN_SUCCESS = 'REOPEN_SUCCESS';
export const reopenSuccess = (data) => ({
  type: REOPEN_SUCCESS,
  payload: data,
});

// Re-open Error Action
export const REOPEN_ERROR = 'REOPEN_ERROR';
export const reopenError = (data) => ({
  type: REOPEN_ERROR,
  payload: data,
});

// Void Modal Action
export const OPEN_VOID_MODAL = 'OPEN_VOID_MODAL';
export const CLOSE_VOID_MODAL = 'CLOSE_VOID_MODAL';
export const voidModal = (type) => ({
  type,
});

// Return Modal Action
export const OPEN_RETURN_MODAL = 'OPEN_RETURN_MODAL';
export const CLOSE_RETURN_MODAL = 'CLOSE_RETURN_MODAL';
export const returnModal = (type) => ({
  type,
});

// Change Due Modal Action
export const OPEN_CHANGE_DUE_MODAL = 'OPEN_CHANGE_DUE_MODAL';
export const CLOSE_CHANGE_DUE_MODAL = 'CLOSE_CHANGE_DUE_MODAL';
export const changeDueModal = (type) => ({
  type,
});

// Form actions & types
export const VOID_FORM_ACTION = 'orderDetails/VOID_FORM_ACTION';
export const voidFormAction = Nested.nestedAction(VOID_FORM_ACTION);

export const RETURN_FORM_ACTION = 'orderDetails/RETURN_FORM_ACTION';
export const returnFormAction = Nested.nestedAction(RETURN_FORM_ACTION);

export const RECEIPT_FORM_ACTION = 'orderDetails/RECEIPT_FORM_ACTION';
export const receiptFormAction = Nested.nestedAction(RECEIPT_FORM_ACTION);

export const SUBMIT_SEND_RECEIPT = 'orderDetails/SUBMIT_SEND_RECEIPT';
export const submitSendReceipt = (payload) => ({
  type: SUBMIT_SEND_RECEIPT,
  payload,
});
export const SUBMIT_PRINT_RECEIPT = 'orderDetails/SUBMIT_PRINT_RECEIPT';
export const submitPrintReceipt = (payload) => ({
  type: SUBMIT_PRINT_RECEIPT,
  payload,
});

export const SEND_RECEIPT_SUCCESS = 'orderDetails/SEND_RECEIPT_SUCCESS';
export const sendReceiptSuccess = (payload) => ({
  type: SEND_RECEIPT_SUCCESS,
  payload,
});

export const SEND_RECEIPT_ERROR = 'orderDetails/SEND_RECEIPT_ERROR';
export const sendReceiptError = () => ({
  type: SEND_RECEIPT_ERROR,
});

export const PRINT_RECEIPT_SUCCESS = 'orderDetails/PRINT_RECEIPT_SUCCESS';
export const printReceiptSuccess = (payload) => ({
  type: PRINT_RECEIPT_SUCCESS,
  payload,
});

export const PRINT_RECEIPT_ERROR = 'orderDetails/PRINT_RECEIPT_ERROR';
export const printReceiptError = () => ({
  type: PRINT_RECEIPT_ERROR,
});

export const INITIATE_CANCEL_PAYLINK = 'orderDetails/INITIATE_CANCEL_PAYLINK';
export const initiateCancelPaylink = (data) => ({
  type: INITIATE_CANCEL_PAYLINK,
  payload: data,
});

export const CANCEL_PAYLINK_SUCCESS = 'orderDetails/CANCEL_PAYLINK_SUCCESS';
export const cancelPaylinkSuccess = (data) => ({
  type: CANCEL_PAYLINK_SUCCESS,
  payload: data,
});

export const CANCEL_PAYLINK_ERROR = 'orderDetails/CANCEL_PAYLINK_ERROR';
export const cancelPaylinkError = (data) => ({
  type: CANCEL_PAYLINK_ERROR,
  payload: data,
});

// Raw Reducer
export const _reducer = (state = initialState, { type, payload } = action) => {
  switch (type) {
    case GET_ORDER_DETAILS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case GET_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        data: payload,
        fetching: false,
        error: false,
        isPaylinkCancelled: false,
      };
    case GET_ORDER_DETAILS_ERROR:
      return {
        ...state,
        error: true,
        fetching: false,
        errorText: payload,
      };
    case OPEN_VOID_MODAL:
      return {
        ...state,
        isVoidModalOpen: true,
      };
    case CLOSE_VOID_MODAL:
      return {
        ...state,
        isVoidModalOpen: false,
      };
    case OPEN_RETURN_MODAL:
      return {
        ...state,
        isReturnModalOpen: true,
      };
    case CLOSE_RETURN_MODAL:
      return {
        ...state,
        isReturnModalOpen: false,
      };
    case OPEN_CHANGE_DUE_MODAL:
      return {
        ...state,
        isChangeDueModalOpen: true,
      };
    case CLOSE_CHANGE_DUE_MODAL:
      return {
        ...state,
        isChangeDueModalOpen: false,
        changeDue: initialState.changeDue,
      };
    case INITIATE_VOID:
      return {
        ...state,
        isLoading: true,
      };
    case VOID_ERROR:
      return {
        ...state,
        isLoading: false,
        isVoidModalOpen: false,
        isVoidError: true,
      };
    case VOID_SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          transaction_details: payload.data.transaction_details,
          order: {
            ...state.data.order,
            status: payload.data.status,
            voidable: payload.data.voidable,
          },
        },
        isLoading: false,
        isVoidModalOpen: false,
        changeDue: payload.changeDue,
      };
    case PAYMENT_SUCCESS:
      return {
        ...state,
        changeDue: formatCurrency(payload.data.change_due),
      };
    case INITIATE_RETURN:
      return {
        ...state,
        isLoading: true,
      };
    case RETURN_ERROR:
      return {
        ...state,
        isCardReturnError: true,
        isLoading: false,
      };
    case RETURN_SUCCESS:
      return {
        ...state,
        order: payload.order,
        isCardReturnError: false,
        isLoading: false,
      };
    case INITIATE_REOPEN:
      return {
        ...state,
        isLoading: true,
      };
    case REOPEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isReopenOrderError: false,
      };
    case REOPEN_ERROR:
      return {
        ...state,
        isLoading: false,
        isReopenOrderError: true,
      };
    case SUBMIT_PRINT_RECEIPT:
      return {
        ...state,
        isPrintReceiptLoading: true,
      };
    case PRINT_RECEIPT_ERROR:
      return {
        ...state,
        isPrintReceiptLoading: false,
      };
    case PRINT_RECEIPT_SUCCESS:
      return {
        ...state,
        isPrintReceiptLoading: false,
      };
    case SUBMIT_SEND_RECEIPT:
      return {
        ...state,
        isSendReceiptLoading: true,
      };
    case SEND_RECEIPT_ERROR:
      return {
        ...state,
        isSendReceiptLoading: false,
      };
    case SEND_RECEIPT_SUCCESS:
      return {
        ...state,
        isSendReceiptLoading: false,
      };
    case INITIATE_CANCEL_PAYLINK:
      return {
        ...state,
        isLoading: true,
      };
    case CANCEL_PAYLINK_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isPaylinkCancelled: true,
      };
    case CANCEL_PAYLINK_ERROR:
      return {
        ...state,
        isLoading: false,
        error: true,
        isPaylinkError: true,
        isPaylinkCancelled: false,
      };
    default:
      return state;
  }
};

// Raw Redux Maps
export const _mapStateToProps = (state) => ({
  ...state.orderDetails,
});
export const _mapDispatchToProps = (dispatch) => ({
  getOrderDetails: (id) => dispatch(getOrderDetailsRequest(id)),
  initiateVoidOrderById: (id) => dispatch(initiateVoidOrderById(id)),
  submitSendReceipt: (payload) => dispatch(submitSendReceipt(payload)),
  submitPrintReceipt: (payload) => dispatch(submitPrintReceipt(payload)),
});

// Nested Redux Maps
const {
  reducer: nestedReducer,
  mapStateToProps,
  mapDispatchToProps,
  actions,
} = Nested.nestStates(
  {
    reducer: _reducer,
    mapStateToProps: _mapStateToProps,
    mapDispatchToProps: _mapDispatchToProps,
  },
  {
    modals: {
      voidingModal: {
        ...ModalState,
        actionType: VOIDING_MODAL_ACTION,
      },
      refundingModal: {
        ...ModalState,
        actionType: REFUNDING_MODAL_ACTION,
      },
      loadingModal: {
        ...ModalState,
        actionType: LOADING_MODAL_ACTION,
      },
      changeDueModal: {
        ...ModalState,
        actionType: CHANGE_DUE_MODAL_ACTION,
      },
    },
    alertBars: {
      orderDetailsAlertBars: {
        ...AlertBarState,
        actionType: ALERT_BAR_ACTION,
      },
    },
    forms: {
      voidForm: {
        ...VoidForm,
        actionType: VOID_FORM_ACTION,
      },
      returnForm: {
        ...ReturnForm,
        actionType: RETURN_FORM_ACTION,
      },
      receiptForm: {
        ...ReceiptForm,
        actionType: RECEIPT_FORM_ACTION,
      },
    },
  },
  'orderDetails',
);

// Nested Reducer
const reducer = (state, action) => nestedReducer(state, action);

export { reducer, mapStateToProps, mapDispatchToProps, actions };
